module.exports={
    "Close": "Luk",
    "Headline": "Overskrift...",
    "Choose how to share": "VÃ¦lg, hvordan du deler"
  }
  